import View from "./view.js";
import GlobeViewport from "../viewports/globe-viewport.js";
import GlobeController from "../controllers/globe-controller.js";
export default class GlobeView extends View {
    static { this.displayName = 'GlobeView'; }
    constructor(props = {}) {
        super(props);
    }
    get ViewportType() {
        return GlobeViewport;
    }
    get ControllerType() {
        return GlobeController;
    }
}
